import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Users, TrendingUp, DollarSign, ArrowRight } from 'lucide-react';
import PortalLayout from './PortalLayout';

const muted = { color: 'var(--p-muted)' };

export default function ClientAffiliates() {
  return (
    <PortalLayout active="affiliates">
      <div className="mb-8" data-testid="portal-affiliates">
        <span className="text-xs tracking-[0.2em] uppercase text-[#F97316] font-semibold p-eyebrow">Earn With DCA</span>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-light mt-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Affiliate Program
        </h1>
        <p className="mt-2 max-w-2xl" style={muted}>Refer entrepreneurs to DCA and earn on every program they join.</p>
      </div>

      <div className="relative rounded-2xl overflow-hidden border" style={{ borderColor: 'var(--p-border)' }} data-testid="portal-affiliates-locked">
        <div className="grid sm:grid-cols-3 gap-6 p-8 blur-[2px] opacity-60 pointer-events-none select-none">
          {[
            { icon: Users, t: 'Your referral link', d: 'Share a unique link and track every signup.' },
            { icon: TrendingUp, t: 'Real-time stats', d: 'Clicks, signups and conversions in one view.' },
            { icon: DollarSign, t: 'Recurring payouts', d: 'Earn commission on programs and subscriptions.' },
          ].map((c, i) => (
            <div key={i} className="p-card rounded-xl p-6">
              <c.icon size={22} className="text-[#1D4ED8] mb-3" />
              <div className="font-semibold">{c.t}</div>
              <div className="text-sm mt-1" style={muted}>{c.d}</div>
            </div>
          ))}
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center backdrop-blur-sm text-center px-6" style={{ background: 'color-mix(in srgb, var(--p-bg) 72%, transparent)' }}>
          <span className="w-14 h-14 rounded-full bg-[#F97316]/12 text-[#F97316] flex items-center justify-center mb-4">
            <Lock size={26} />
          </span>
          <h3 className="text-xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Coming soon</h3>
          <p className="text-sm mt-2 max-w-md" style={muted}>The DCA Affiliate Program is being finalized. You'll be able to grab your referral link and start earning right here. Watch your email for the launch.</p>
          <Link to="/portal" className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-[#1D4ED8] hover:underline">
            Back to dashboard <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </PortalLayout>
  );
}
